import { render, staticRenderFns } from "./report-table.vue?vue&type=template&id=b4571278&scoped=true"
import script from "./report-table.vue?vue&type=script&setup=true&lang=js"
export * from "./report-table.vue?vue&type=script&setup=true&lang=js"
import style0 from "./report-table.vue?vue&type=style&index=0&id=b4571278&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4571278",
  null
  
)

export default component.exports